import React from 'react';
import { useHistory } from 'react-router-dom';
import PhoneFrame from '../components/PhoneFrame';
import StudentDesktopSettingsPage, { loadStudentPreferences, storeStudentPreferences } from '../../studentDesktop/page/StudentDesktopSettingsPage';

// v2 mobile Settings: the same settings page and options as desktop (teacher
// voice, Normal/Fast audio, grading), shown inside the phone frame.
export default function StudentSettings() {
    const history = useHistory();
    const [preferences] = React.useState(loadStudentPreferences);

    return (
        <PhoneFrame title="Settings" onBack={() => history.push('/mockup/v2/student/profile')}>
            <StudentDesktopSettingsPage
                embedded
                preferences={preferences}
                onSave={next => {
                    storeStudentPreferences(next);
                    history.push('/mockup/v2/student/profile', { notice: 'Settings saved.' });
                }}
            />
        </PhoneFrame>
    );
}
